export const isExternal = (href: string): boolean =>
  href.includes("http") || href.includes("mailto:")

export const isGlossary = (href: string): boolean =>
  href.includes("glossary") && href.includes("#")

